<script setup lang="ts">
import {ref} from "vue";
import {SectionService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import EditLiveSectionForm from "components/dialog/live/inner/EditLiveSectionForm.vue";
import {SaveLiveSection} from "@/types";

let courseId = 0
let sectionId = 0
const is_fake = ref(false)
const loading = ref(false);
const visible = ref(false)
const editLiveSectionForm = ref<InstanceType<typeof EditLiveSectionForm>>()

const show = (_courseId: number, _sectionId: number, _is_fake: boolean) => {
  courseId = _courseId
  sectionId = _sectionId
  is_fake.value = _is_fake
  visible.value = true
  getSectionInfo()
}

const getSectionInfo = async () => {
  try {
    loading.value = true;
    const res = await SectionService.getSectionInfo({
      course_id: courseId,
      section_id: sectionId
    })
    if (res.data.code === 200) {
      editLiveSectionForm.value?.init(res.data.data)
    } else {
      ElNotification.error({
        title: "获取信息失败",
        message: res.data.msg,
        type: "error"
      })
    }
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
  }
}

const hide = () => {
  visible.value = false
}

const emit = defineEmits(['on-submit'])

const onSubmit = (info: SaveLiveSection) => {
  info.section_id = sectionId
  emit("on-submit", info)
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog title="编辑章节" width="50rem" align-center v-model="visible" :close-on-click-modal="false">
    <edit-live-section-form
        :is_fake="is_fake" ref="editLiveSectionForm"
        @on-submit="onSubmit" @on-close="hide"
        v-loading="loading"/>
  </el-dialog>
</template>

<style scoped>
</style>
